(() => {
  const root = document.querySelector('[data-pqp-track123]');
  if (!root) return;

  const pageTitle = 'Track Your Order | Peptide Quick Pens';
  const pageDescription = 'Track your Peptide Quick Pens order and view the latest delivery updates.';
  const pageCanonical = `${window.location.origin}/track`;
  if (window.location.pathname === '/apps/track123' && window.history?.replaceState) {
    window.history.replaceState(null, pageTitle, `/track${window.location.search}${window.location.hash}`);
  }
  document.title = pageTitle;

  const normalizeMeta = () => {
    const head = document.head;

    const titles = Array.from(document.querySelectorAll('title'));
    if (titles.length) {
      titles[0].textContent = pageTitle;
      if (titles[0].parentElement !== head) head.appendChild(titles[0]);
      titles.slice(1).forEach((node) => node.remove());
    } else {
      const title = document.createElement('title');
      title.textContent = pageTitle;
      head.appendChild(title);
    }

    const descriptions = Array.from(document.querySelectorAll('meta[name="description"]'));
    if (descriptions.length) {
      descriptions[0].setAttribute('content', pageDescription);
      if (descriptions[0].parentElement !== head) head.appendChild(descriptions[0]);
      descriptions.slice(1).forEach((node) => node.remove());
    } else {
      const description = document.createElement('meta');
      description.name = 'description';
      description.content = pageDescription;
      head.appendChild(description);
    }

    const canonicals = Array.from(document.querySelectorAll('link[rel="canonical"]'));
    if (canonicals.length) {
      canonicals[0].setAttribute('href', pageCanonical);
      if (canonicals[0].parentElement !== head) head.appendChild(canonicals[0]);
      canonicals.slice(1).forEach((node) => node.remove());
    } else {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = pageCanonical;
      head.appendChild(canonical);
    }
  };

  normalizeMeta();

  const helperToggle = root.querySelector('[data-pqp-track123-helper-toggle]');
  const helperPanel = root.querySelector('[data-pqp-track123-helper-panel]');

  if (helperToggle && helperPanel) {
    helperToggle.addEventListener('click', () => {
      const willOpen = helperToggle.getAttribute('aria-expanded') !== 'true';
      helperToggle.setAttribute('aria-expanded', String(willOpen));
      helperPanel.hidden = !willOpen;
    });
  }

  const prepareWidget = () => {
    const app = root.querySelector('#track123-app');
    if (!app) return;

    document.title = pageTitle;
    normalizeMeta();

    const tabs = app.querySelectorAll('.track123_tab_bar');
    const trackingLabel = app.querySelector('#track123_tracking_number');
    const trackingWrapper = trackingLabel?.closest('.track123_input_wrapper');

    if (tabs.length > 1 && trackingWrapper && !root.dataset.trackingModeSelected) {
      root.dataset.trackingModeSelected = 'true';
      tabs[1].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      window.setTimeout(() => root.classList.add('pqp-track123--tracking-ready'), 0);
    } else if (trackingWrapper) {
      root.classList.add('pqp-track123--tracking-ready');
    }

    if (trackingLabel) {
      trackingLabel.textContent = 'Tracking number';
      const input = trackingLabel.parentElement?.querySelector('input');
      if (input) {
        input.placeholder = 'Enter your tracking number';
        input.setAttribute('aria-labelledby', trackingLabel.id);
        input.setAttribute('autocomplete', 'off');
      }
    }

    const trackingButton = trackingWrapper?.querySelector('.track123_form_button');
    if (trackingButton) trackingButton.textContent = 'TRACK ORDER';
  };

  let framePending = false;
  const schedulePrepare = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(() => {
      framePending = false;
      prepareWidget();
    });
  };

  const widgetHost = root.querySelector('[data-pqp-track123-widget]');
  if (widgetHost) {
    const observer = new MutationObserver(schedulePrepare);
    observer.observe(widgetHost, { childList: true, subtree: true });
  }

  prepareWidget();
  window.addEventListener('load', prepareWidget, { once: true });
  window.setTimeout(prepareWidget, 800);
  window.setTimeout(normalizeMeta, 1200);
})();
